import * as React from 'react';
import { FileType } from '@/interfaces';
import {
	getReviewSignStatus,
	isReviewSignDocument,
	shouldOpenDocumentModal,
} from '@/utils/caseDocumentation';
import { DocumentationRowAlerts } from './DocumentationRowAlerts';
import { DocumentationRowActions } from './DocumentationRowActions';

interface DocumentationRowProps {
	item: FileType;
	isDeclined: boolean;
	onClickModal: (record: FileType) => void;
}

export const DocumentationRow: React.FC<DocumentationRowProps> = ({
	item,
	isDeclined,
	onClickModal,
}) => {
	const isReviewSign = !!isReviewSignDocument(item);
	const isShowModal = !!shouldOpenDocumentModal(item);
	const reviewStatus = getReviewSignStatus(item);

	return (
		<li className="flex justify-between items-center gap-x-2 mb-2 px-2 py-[14px] bg-grey-2 rounded-2xl overflow-hidden">
			<DocumentationRowAlerts
				item={item}
				isReviewSign={isReviewSign}
				reviewStatus={reviewStatus}
				isDeclined={isDeclined}
			/>
			<DocumentationRowActions
				item={item}
				isReviewSign={isReviewSign}
				isShowModal={isShowModal}
				reviewStatus={reviewStatus}
				onClickModal={onClickModal}
			/>
		</li>
	);
};
